import React from 'react'
import Footer from "./Footer";
import "../css/Contact.css";
import { MetaTags } from "react-meta-tags";
import $ from 'jquery';
const Contact = () => {
    const formSubmit = () => {
        var custName;
        var custEmail;
        var custPhone;
        var custEvent;
        var custMessage;
    
        if ($("#custName").val() !== "") {
          custName = $("#custName").val();
        } else {
        }

        if ($("#custPhone").val() !== "") {
          custPhone = $("#custPhone").val();
        } else {
        }
       
        if ($("#custEmail").val() !== "") {
          custEmail = $("#custEmail").val();
        } else {
        }
    if ($("#custEvent").val() !== "") {
          custEvent= $("#custEvent").val();
        } else {
        }
        if ($("#custMessage").val() !== "") {
          custMessage = $("#custMessage").val();
        } else {
        }
        
        var body =
          '<!DOCTYPE html><html><head><title>The Express Caterers</title><meta http-equiv="Content-Type" content="text/html; charset=utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><meta http-equiv="X-UA-Compatible" content="IE=edge"></head><body style="margin:0!important;padding:0!important;background-color:#eee" bgcolor="#eeeeee"><div style="display:none;font-size:1px;color:#fefefe;line-height:1px;font-family:Open Sans,Helvetica,Arial,sans-serif;max-height:0;max-width:0;opacity:0;overflow:hidden"></div><table border="0" cellpadding="0" cellspacing="0" width="100%" bgcolor="#fff"><tr><td align="center" style="background-color:#eee" bgcolor="#eeeeee"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px"><tr><td align="center" valign="top" style="font-size:0;padding:10px" bgcolor="#e56f35"><div style="display:inline-block;max-width:100%;min-width:100px;vertical-align:top;width:100%"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%"><tr><td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:6px;font-weight:800;line-height:10px" class="mobile-center"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px"><tr><td width="100%" align="center" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:800;line-height:24px;padding:10px"><a href="tel:+91" style="text-decoration:none;color:#fff;font-family:serif;font-size:16px">Leads Generate for The Express Caterers</a></td></tr></table></td></tr></table></div></td></tr><tr><td align="center" valign="top" style="font-size:0;padding:15px" bgcolor="#fff"><div style="display:inline-block;max-width:100%;min-width:100px;vertical-align:top;display:fle;justify-content:center;align-items:center;width:100%"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%"><tr><td align="center" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:36px;font-weight:800;line-height:48px" class="mobile-center"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px"><tr><td width="100%" align="center" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-weight:800"><img style="width:120px;height:120px" src="" alt=""></td></tr></table></td></tr></table></div></td></tr><tr><td align="center" valign="top" style="font-size:0;padding:0" bgcolor="#e56f35"><div style="display:inline-block;max-width:100%;min-width:100px;vertical-align:top;display:fle;justify-content:center;align-items:center;width:100%"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%"><tr><td width="100%" align="center" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:800;padding:10px 0" class="mobile-center"><h1 style="text-transform:capitalize;font-size:14px;font-weight:500;margin:0;text-align:center;color:#fff">Client Enquiry Details</h1></td></tr></table></div></td></tr><tr><td align="center" height="100%" valign="top" width="100%" style="padding:0 35px 35px 35px;background-color:#fff" bgcolor="#eee"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:660px"><tr><td width="100%" align="center" valign="top" style="font-size:0"><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;text-align:center;width:100%"><table width="100%" align="center" border="0" cellpadding="0" cellspacing="0" style="max-width:300px"><tr><td width="100%" align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"><p style="font-size:16px;font-weight:600;color:#e56f35">Customer Name:</p><p style="font-size:14px;font-weight:500;color:#111">' +
          custName +
          '</p></td></tr></table></div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"><tr><td width="100%" align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"><p style="font-size:16px;font-weight:600;color:#e56f35">Customer Number:</p><p style="font-size:14px;font-weight:500;color:#111">' +
          custPhone +
          '</p></td></tr></table></div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"><tr><td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"><p style="font-size:16px;font-weight:600;color:#164388">Customer Email:</p><p style="font-size:14px;font-weight:500;color:#111">' +
          custEmail +
          '</p></td></tr></table></div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"><tr><td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"><p style="font-size:16px;font-weight:600;color:#164388">Event:</p><p style="font-size:14px;font-weight:500;color:#111">' +
          custEvent+
          '</p></td></tr></table></div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"><tr><td width="100%" align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"><p style="font-size:16px;font-weight:600;color:#e56f35">Customer Message:</p><p style="font-size:14px;font-weight:500;color:#111">' +
         
          custMessage +
          '</p></td></tr></table></div></td></tr></table></td></tr><tr><td width="100%" align="center" bgcolor="#e56f35" style="padding:10px 0"><p style="color:#fff;font-weight:500;font-size:1rem;padding:0;margin:0">© Copyright 2023 The Express Caterers</p></td></tr></table></td></tr></table></body></html>';
    
        $.post(
          "https://skdm.in/server/v1/send_lead_mail.php",
          {
            toEmail: "theexpresscaterers@gmail.com",
            
            fromEmail: "skdmlead@gmail.com",
            bccMail: "skdmlead@gmail.com",
            mailSubject: "New Lead genration",
            mailBody: body,
            accountName: "Express cater",
            accountLeadSource: "http://sundarfarms.com/",
            accountLeadName: custName,
            accountLeadPhone: custPhone,
            accountLeadEmail: custEmail,
           
            accountLeadEvent: custEvent,
          },
    
          function (dataa, status) {
            console.log("data :" + dataa);
            console.log("name:" + custName);
          }
        );
    
        alert("Your Form has Submited Our team will contact with You  soon.");
    
        window.location.reload();
    
        return false;
      };
  return (
    <>
 {/* --------------------------------seo start--------------------------------- */}
 <MetaTags>
        <title>
          {" "}
          Best Food Caterers in Dahisar | The Express Caters
        </title>
        <meta name="google-site-verification" content="7SedB4wBTSXQ-5jGmNcsjt5cV7hPKrgS31utL8lPh3c" />
        <meta
          name="description"
          content="Looking for the Best Food Caterers in Dahisar to make your events memorable? Explore top-notch catering services that add deliciousness to your celebrations"
        />
        <meta
          name="keywords"
          content="Caterers in Dahisar,
          Wedding Caterers in Dahisar,
          Best Cateres In Dahisar,
          Party Cateres In Dahisar,
          Best food Cateres In Dahisar"
        />
        <meta
          property="og:title"
          content="Best Food Caterers in Dahisar | The Express Caters"
        />
        <meta
          property="og:description"
          content="Looking for the Best Food Caterers in Dahisar to make your events memorable? Explore top-notch catering services that add deliciousness to your celebrations"
        />
        <link
          rel="canonical"
          href="https://theexpresscaterers.in/best-food-caterers-in-dahisar"
        />

<meta http-equiv="cache-control" content="no-cache" />
        <meta http-equiv="expires" content="0" />
        <meta http-equiv="pragma" content="no-cache" />
        <meta property="og:title" content="Best Food Caterers in Dahisar | The Express Caters" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://theexpresscaterers.in/" />
        <meta property="og:description" 
        content="Looking for the Best Food Caterers in Dahisar to make your events memorable? Explore top-notch catering services that add deliciousness to your celebrations" />

      </MetaTags>
       {/* --------------------------------seo end--------------------------------- */}

    <section class="contact-page-section">
      <div class="container">
          <div class="sec-title">
              <div class="title">Contact Us</div>
                <h1>Best Food Caterers In Dahisar</h1>
                <p className="d-none">Thank you for considering Best Food Caterers in Dahisar for your upcoming event. We're dedicated to delivering exceptional catering services tailored to your preferences and needs. Whether it's a wedding, corporate gathering, or any special occasion, our team is here to make your event truly memorable. Feel free to reach out to us via the contact information below, and let's discuss how we can create a culinary experience that exceeds your expectations. We look forward to serving you soon!</p>
            </div>
            <div class="inner-container">
              <div class="row clearfix">
{/*                 
                  <!--Form Column--> */}
                    <div class="form-column col-md-8 col-sm-12 col-xs-12">
                      <div class="inner-column">
                          
                            {/* <!--Contact Form--> */}
                            <div class="contact-form">
                                <form method="post" action="" id="contact-form">
                                    <div class="row clearfix">
                                        <div class="form-group col-md-6 col-sm-6 co-xs-12">
                                            <input type="text" name="name" placeholder="Name" id="custName" required/>
                                        </div>
                                        <div class="form-group col-md-6 col-sm-6 co-xs-12">
                                            <input type="email" name="email" placeholder="Email" id="custEmail" required/>
                                        </div>
                                        <div class="form-group col-md-6 col-sm-6 co-xs-12">
                                            <input type="text" name="Event"  placeholder="Event" id="custEvent" required/>
                                        </div>
                                        <div class="form-group col-md-6 col-sm-6 co-xs-12">
                                            <input type="text" name="phone" placeholder="Phone" id="custPhone" required/>
                                        </div>
                                        <div class="form-group col-md-12 col-sm-12 co-xs-12">
                                            <textarea name="message" placeholder="Massage" id="custMessage"></textarea>
                                        </div>
                                        <div class="form-group col-md-12 col-sm-12 co-xs-12">
                                            <button type="submit"  onClick={formSubmit} class="theme-btn btn-style-one">Send Now</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            {/* <!--End Contact Form--> */}
                            
                        </div>
                    </div>
                    
                    {/* <!--Info Column--> */}
                    <div class="info-column col-md-4 col-sm-12 col-xs-12">
                      <div class="inner-column">
                          <h2>Contact Info</h2>
                            <ul class="list-info">
                              <li><i class="fa fa-globe"></i>Shop No. 1, Sai Complex CHS , Kanderpda Extn. , Opp, New Link Rd, Dahisar West, Mumbai, Maharashtra 400068</li>
                                <li><i class="fa fa-envelope"></i>theexpresscaterers@gmail.com</li>
                                <li><i class="fa fa-phone"></i>9820143669 <br/> 9820124036</li>
                            </ul>
                            <ul class="social-icon-four">
                                <li class="follow">Follow on: </li>
                                <li><a href="https://www.facebook.com/theexpresscaterers?mibextid=ZbWKwL"><i class="fa fa-facebook"></i></a></li>
                                <li><a href="https://www.instagram.com/p/CpuzdZfvWNe/?igshid=MDJmNzVkMjY="><i class="fa fa-instagram"></i></a></li>
                                <li><a href="https://goo.gl/maps/7s6vp7hBnHqKaKA28"><i class="fa fa-google"></i></a></li>
                               
                            </ul>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </section>
     <Footer />
     </>
  )
}

export default Contact
